export default "__VITE_ASSET__DSejfxQk__"